// extracted by mini-css-extract-plugin
module.exports = {"inputItem":"requestDetailsForm_inputItem__14NZd"};